interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function ModalSection({ children, className }: Props) {
  const classes = [
    'rounded-2xl border border-slate-200 bg-white p-4',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={classes}>{children}</div>;
}
